import {
  Button,
  Card,
  CardBody, CardHeader,
  Col,
  Container, Modal, ModalBody, ModalFooter, ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  Table,
  TabPane
} from "reactstrap";

import VideoJS from "../../video/videoJS.components";
import React, {useCallback, useEffect, useState} from "react";
import {timeUtil} from "../utils/time";
import './sessionView.scss';
import {useQuery} from "../../../../hook/useQuery";
import {useDispatch, useSelector} from "react-redux";
import {SessionActions} from "../../../../store/session/session.action";
import {SessionSelectors} from "../../../../store/session/session.selector";
import {SessionsSelectors} from "../../../../store/sessions/sessions.selector";
import {Transcription} from "../../transcription/Transcription";
import {transcription as transcriptionApi} from "../../../../api/trascription";
import {transcriptionUtils} from "../../../../utils/trascription.utils";
import SessionNotFound from "../components/notFound/SessionNotFound";
import {downloadFile, downloadIndex} from "../../../../utils/download.utils";
import {RoundedDropdown} from "../../roundedDropdown/RoundedDropdown";
import {SocialShare} from "../../socialShare/SocialShare";
import {UserSelectors} from "../../../../store/user/user.selector";
import {toast} from "react-toastify";
import avatarImg from "../../../../assets/images/avatar.jpg";
import config from '../../../../app/config';

const {timeToStringFormat} = timeUtil;
const fileExtList = ['pvt', 'pvml', 'srt', 'txt', 'vtt','docx'];

function SessionView() {
  const query = useQuery();
  const dispatch = useDispatch();
  const session = useSelector(SessionSelectors.get);
  const sessionLoading = useSelector(SessionSelectors.isLoading);
  const sessionError = useSelector(SessionSelectors.isError);

  const sessions = useSelector(SessionsSelectors.get);
  const sessionsLoading = useSelector(SessionsSelectors.isLoading);
  const sessionsError = useSelector(SessionsSelectors.isError);

  const isUserLogged = useSelector(UserSelectors.isUserLogged);

  const [videoLoaded, setVideoLoaded] = useState(false);

  const sessionId = query.get('id');
  const seekTime = query.get('seek');
  const [shareUrl, _] = useState(`${config.serverUrl}/sessions/view?id=${sessionId}`);
  const playerRef = React.useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [playerTime, setPlayerTime] = useState('');
  const [tab, setTab] = useState("2");
  const [videoJsOptions, setVideoJsOptions] = useState(
    { // lookup the options in the docs for more options
      autoplay: false,
      controls: true,
      responsive: true,
      fluid: true,
      sources: [{
        src: '',
        type: 'video/mp4'
      }]
    }
  )
  const [timeNotes, setTimeNotes] = useState([])
  const [showIndex, setShowIndex] = useState(true)
  const [showInteractiveTranscriptionTabs, setShowInteractiveTranscriptionTabs] = useState(true)

  const [transcription, setTranscription] = useState();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(prev => !prev);

  useEffect(()=>{
    return () =>{
      dispatch(SessionActions.reset());
    }
  },[])
  useEffect(() => {
    if (sessionId) {
      console.log(sessionId);
      dispatch(SessionActions.fetchSessionById(sessionId))
    }
  }, [sessionId])

  useEffect(() => {
    if (session) {
      const parsedTimeNotes = session.timenote ? JSON.parse(session.timenote) : []
      
      setTimeNotes(parsedTimeNotes);

      if (parsedTimeNotes.length > 0) {
        setShowIndex(true);
        setTab("1");
      } else {
        setShowIndex(false);
        setTab("2");        
      }
      setShowInteractiveTranscriptionTabs(!config.hidePublicTranscriptionTabs);

      console.log(session.speakers);
      
      // console.log('parsedTimeNotes: ' + parsedTimeNotes.length + " | Show index: " + showIndex);
      // console.table(parsedTimeNotes);

      if (session.linkVideo) {
        setVideoJsOptions(v => {
          const videoOptions = v;
          videoOptions.sources[0].src = session.linkVideo;
          return videoOptions
        })
        setVideoLoaded(true);
      }
	  if (session.trascrizioni?.pvt || session.trascrizioni?.originalFile) {
        loadTranscription(session.trascrizioni.pvt || session.trascrizioni.originalFile);
      }
    }
  }, [session]);

  async function loadTranscription(link) {
    const transcriptionResult = await transcriptionApi.methods.getTranscription(link);
    const convertedXml = transcriptionUtils.methods.convertXmlToJson(transcriptionResult);
    const cleanedJSON = convertedXml.replace(/"_/g, '"');

    try {
      setTranscription(JSON.parse(cleanedJSON))
    } catch (e) {
      setTranscription({})
    }
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });

    //
    player.on('timeupdate', (e) => {
      setCurrentTime(player.currentTime().toFixed(1))
      const time = player.currentTime().toFixed(0);
      setPlayerTime(timeToStringFormat(time*1000))

    })

	if (session.trascrizioni?.vtt){
		player.addRemoteTextTrack({src: session.trascrizioni.vtt, type: 'text/vtt', default: 'default', kind: 'subtitles', srclang: 'it', label: 'Italiano'}, true);
		player.textTracks()[0].mode = "showing";
		console.debug('Add subtitle capition');
	}

    if (seekTime) {
      console.log('Seektime found, moving current time', seekTime)
      goToTime(seekTime)
    }
  };

  function renderDescription(timeNote) {
    const {evento, speaker, fase, testo} = timeNote;
    if (evento.id === 1) {
      return speaker
    }
    if (evento.id === 2) {
      return fase.name
    }
    if (evento.id === 3) {
      return testo
    }
  }

  function showTimedNotes(speaker_id) {
    const collection = document.getElementsByClassName("speaker_timed_notes");
    for (const element of collection) {
      element.classList.add('hidden');
    }
    
    const element = document.getElementById(speaker_id);
    element.classList.remove("hidden");
    
    const overlay = document.getElementById('black_overlay');
    element.classList.remove("hidden");
    console.log(speaker_id);
  }

  function hideTimedNotes(speaker_id) {
    const element = document.getElementById(speaker_id);
    element.classList.add("hidden");
    const overlay = document.getElementById('black_overlay');
    element.classList.add("hidden");
    console.log(speaker_id);
  }

  function goToTime(time) {
    playerRef.current.currentTime(time / 1000)
  }

    function goToTimeAndClose(time, speaker_id) {
    playerRef.current.currentTime(time / 1000);
    hideTimedNotes(speaker_id);
  }

  function handleExtension(ext) {
    if (!session.trascrizioni?.[ext]) {
      console.log('non trovata!');
      setModal(true)
    } else {
      downloadFile(session.trascrizioni?.[ext], session.name);
    }
  }

  const onWordClicked = useCallback((word)=>{
    playerRef.current.currentTime(word.startTime)
  },[playerTime.current])

  return (
    <div className="streaming-container">
      {sessionLoading && !session ?
        <Spinner/>
        : sessionError ? <SessionNotFound/> :
          <div>
            <Row>
              <Col md="12" sm="12" lg="12"><h2>{session.name}</h2>
              </Col>
            </Row>
            <Row>
              {/*Column SX*/}
              <Col md="7" sm="7" lg="7">
                {videoLoaded && <VideoJS options={videoJsOptions} onReady={handlePlayerReady}/>}
              </Col>
              {/*Column DX*/}
              <Col md="5" sm="5" lg="5">
                {showInteractiveTranscriptionTabs && <Row>
                  <Col sm="12">
                    <Nav className="border-tab-primary no-border" tabs>
                      <NavItem>
                        {showIndex && (
                          <>
                            <NavLink
                              style={{cursor: 'pointer'}}
                              className={tab === "1" ? "active" : ""}
                              onClick={() => setTab("1")}
                            >
                              {/*<i className="icofont icofont-ui-home"></i>Home*/}
                              Indice
                            </NavLink>
                          </>
                        )}

                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{cursor: 'pointer'}}
                          className={tab === "2" ? "active" : ""}
                          onClick={() => setTab("2")}
                        >
                          {/*<i className="icofont icofont-man-in-glasses"></i>Profile*/}
                          Trascrizione interattiva
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={tab}>
                      <TabPane className="fade show" tabId="1">
                        <Row>
                          <Col sm="12">
                            <div
                              className="table-responsive timeslot-table"
                            >  
                              <Table striped>
                                <thead>
                                <tr>
                                  <th scope="col" className="col col-md-2 col-lg-1">#</th>
                                  <th scope="col" className="col col-md-2 col-lg-1"></th>
                                  <th scope="col" className="col col-md-2 col-lg-2">Link</th>
                                  <th scope="col" className="col col-md-2 col-lg-2">Tempo</th>
                                  <th scope="col" className="col col-md-2 col-lg-2">Evento</th>
                                  <th scope="col" className="col col-md-4 col-lg-4">Descrizione</th>
                                </tr>
                                </thead>
                                <tbody>
                                {timeNotes.map((t, ix) => (
                                  <tr key={t.id} onClick={() => goToTime(t.time)} style={{cursor: 'pointer'}}>
                                    <th scope="row" className="col col-md-1 col-lg-1">
                                      {ix + 1} 
                                    </th>
                                    <th scope="row" className="col col-md-1 col-lg-1">
                                      {isUserLogged && t.url && (
                                        <>
                                          <a onClick={() => downloadFile(t.url, `${session.name}_${ix+1}`)}>
                                            <i className="icon-download"></i>
                                          </a>
                                        </>
                                      )}  

                                    </th>
                                    <td className="col col-md-2 col-lg-2">
                                      <i
                                        onClick={() => {
										  let link = `${config.serverUrl}/sessions/view?id=${sessionId}&seek=${t.time}`
                                          navigator.clipboard.writeText(link)
                                          toast.success("Link copiato nella clipboard")
                                        }}
                                        className={'icon-share'}
                                      ></i>
  
                                    </td>
                                    <td className="col col-md-2 col-lg-2">{timeToStringFormat(t.time)}</td>
                                    <td className="col col-md-2 col-lg-2">{t.evento.name}</td>
                                    <td className="col col-md-5 col-lg-5">{renderDescription(t)}</td>
                                  </tr>
                                ))}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <div className="mb-0 m-t-30 transcription-text">                
                          <Transcription
                            currentPlayerTime={playerRef?.current?.currentTime()}
                            transcription={transcription}
                            onWordClicked={onWordClicked}/>
                        </div>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>}
              </Col>
            </Row>
            <div id="fade" class="black_overlay hidden"></div>
            { session.speakers && session.speakers.length > 0 && session.speakers.map((speaker, ix) => (
                <div id={speaker.id} class="hidden speaker_timed_notes" >
                  <div class="close" onClick={() => hideTimedNotes(speaker.id)}>x</div>
                  <h6>{speaker.name} {speaker.surname}</h6>
                  <p><small>{speaker.description}</small> </p>
                  <Row>
                    { speaker.timeNotes && speaker.timeNotes.length > 0 && speaker.timeNotes.map((timenote, ix) => (
                      <Col md="3" sm="4" lg="2" style={{cursor: 'pointer'}} onClick={() => goToTimeAndClose(timenote, speaker.id)}>
                      <i className={'icon-video-camera'}></i> {timeToStringFormat(timenote)}
                      </Col>
                    ))}
                  </Row>
                </div>
              )
            )}
            <Col md="12" sm="12" lg="12">
              { session.speakers && session.speakers.length > 0 && (
                <h3 class="m-t-20">Relatori</h3>
              )}
              <Row>
              { session.speakers && session.speakers.length > 0 && session.speakers.map((speaker, ix) => (
                <Col sm="6" md="4" lg="3" >
                    <div class="m-t-10 pointer" onClick={() => showTimedNotes(speaker.id)}>

                      <Row>
                        
                        <Col sm="3" md="4" lg="4">
                          <img className="rounded img-fluid img-shadow-warning" src={speaker.imageUrl ? speaker.imageUrl : avatarImg} alt=""/>
                        </Col>
                        <Col sm="9" md="8" lg="8">
                          <h6>{speaker.name} {speaker.surname}</h6>
                          <p><small>{speaker.description}</small> </p>
                        </Col>
    
                      </Row>
                    </div>
                </Col>
                )
                 
              )}
              </Row>
            </Col>
            <Col md="12" sm="12" lg="12">
              <Row style={{justifyContent: 'center', marginTop:60}}>
                <SocialShare url={shareUrl} />
              </Row>
            </Col>

            {isUserLogged && (
              <>
                {(session.linkVideo || session.linkTrascrizione) && <Row className="m-t-20">
                  <Col md="7" sm="7" lg="7">
                    <Row style={{justifyContent: 'center'}}>
                      <Card className="card-absolute ">
                        <CardHeader className="bg-primary">
                          <h5>Download</h5>
                        </CardHeader>
                        <CardBody className={'card-flex'}>
                          {session.linkVideo && <Button color="info" className="m-r-20"
                                                        onClick={() => downloadFile(session.linkVideo, session.name)}>Video</Button>}
                          {session.linkMp3 && <Button color="info" className="m-r-20"
                                                        onClick={() => downloadFile(session.linkMp3, session.name)}>Audio</Button>}
                          {session.linkPdf && <Button color="info" className="m-r-20"
                                                        onClick={() => downloadFile(session.linkPdf, session.name)}>PDF</Button>}
                          {showIndex && <Button color="info" className="m-r-20"
                                                        onClick={() => downloadIndex(session)}>Indice</Button>}
                          {session.trascrizioni?.originalFile &&
                          <RoundedDropdown
                            btnText={'Trascrizione'}
                            itemList={fileExtList.map(fl => fl.toUpperCase())}
                            onSelect={ext => handleExtension(ext)}
                          />}
                          <Modal isOpen={modal} toggle={toggle}>
                            <ModalHeader toggle={toggle}>Download trascrizione</ModalHeader>
                            <ModalBody>Al momento la trascrizione con l'estenzione scelta non è disponibile, riprovare più tardi</ModalBody>
                            <ModalFooter>
                              <Button color="primary" onClick={toggle}>
                                OK
                              </Button>
                            </ModalFooter>
                          </Modal>
                        </CardBody>
                      </Card>
                    </Row>
                  </Col>
                </Row>}
              </>
            )}

            {/*todo restore it later*/}
            {/*<Row className="m-t-40 m-b-20">*/}
            {/*  <Col md="12" sm="12" lg="12">*/}
            {/*    <h2>*/}
            {/*      Oratori intervenuti*/}
            {/*    </h2>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*  <Col md="12" sm="12" lg="12">*/}
            {/*    <div className="speaker-list-container">*/}
            {/*      {speakerRenderer()}*/}
            {/*      {speakerRenderer()}*/}
            {/*    </div>*/}
            {/*  </Col>*/}
            {/*</Row>*/}

            {/*{sessions?.length ?*/}
            {/*  <>*/}
            {/*    <Row className="m-t-40 m-b-20">*/}
            {/*      <Col md="12" sm="12" lg="12">*/}
            {/*        <h2>*/}
            {/*          Ultime sedute*/}
            {/*        </h2>*/}
            {/*      </Col>*/}
            {/*    </Row>*/}
            {/*    <Row>*/}
            {/*      <Col md="12" sm="12" lg="12">*/}
            {/*        <div className="session-list-container">*/}
            {/*          {sessions.map(session => {*/}
            {/*            return (*/}
            {/*              <SessionCard*/}
            {/*                key={session.id}*/}
            {/*                card={session}*/}
            {/*              />*/}
            {/*            )*/}
            {/*          })}*/}
            {/*        </div>*/}
            {/*      </Col>*/}
            {/*    </Row>*/}
            {/*  </> :*/}
            {/*  <></>*/}
            {/*}*/}
          </div>
      }
    </div>
  )
}

export default SessionView
